import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Dialog, DialogContent } from '@mui/material'
import { useSnackbar } from 'notistack'
import PropTypes from 'prop-types'

import { useAddQuoteItemsFromPartLibraryMutation } from '@/app/services/quoteItems'
import { useGetQuoteQuery } from '@/app/services/quotes'
import { selectOrganisationId } from '@/app/slices/organisationSlice'
import { setSelectedQuoteStatus } from '@/app/slices/quoteItemsSlice'
import PartLibrary from '@/common/components/PartLibrary/PartLibrary'
import { QUOTE_STATUS_ARRAY } from '@/common/utils/Constants/Constants'

const classes = {
    dialogContent: {
        display: 'flex',
        flexDirection: 'row',
        p: 0,
    },
}

const AddFromPartLibrary = ({ customer, onClose, open }) => {
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar()
    const dispatch = useDispatch()

    const { quoteId } = useParams()
    const organisationId = useSelector((state) => selectOrganisationId(state))

    const { data: selectedQuote } = useGetQuoteQuery({ organisationId, quoteId })
    const [addQuoteItemsFromPartLibrary] = useAddQuoteItemsFromPartLibraryMutation()

    const handleClose = () => {
        onClose()
    }

    const handleAddPartLibraryParts = async (quoteItemsToCreate) => {
        const partsToAdd = []
        quoteItemsToCreate.forEach((partLibraryItem) => {
            const newPart = {
                partLibraryId: partLibraryItem.partLibraryId,
                //partSource: 'partLibrary',
                quantity: partLibraryItem.newQuantity ?? 1,
                //partId: partLibraryItem.partId,
            }
            partsToAdd.push(newPart)
        })

        if (selectedQuote.status !== QUOTE_STATUS_ARRAY.NotCalculated) {
            dispatch(setSelectedQuoteStatus(QUOTE_STATUS_ARRAY.NotCalculated))
        }

        try {
            await addQuoteItemsFromPartLibrary({ organisationId, quoteId, partsToAdd }).unwrap()
            enqueueSnackbar(`${t(`${quoteItemsToCreate.length} parts added to $t(quote)`)}`, { variant: 'success' })
        } catch (error) {
            console.error(error)
            enqueueSnackbar(`${t('An error occurred, please try again.')}`, {
                variant: 'error',
                autoHideDuration: 5000,
            })
        } finally {
            handleClose()
        }
    }

    return (
        <Dialog
            fullScreen={true}
            open={open}
            sx={classes.dialogRoot}
            onClose={handleClose}
        >
            <DialogContent sx={classes.dialogContent}>
                <PartLibrary
                    customer={customer}
                    handlePartsLibrarySubmit={handleAddPartLibraryParts}
                    onCancelClicked={handleClose}
                />
            </DialogContent>
        </Dialog>
    )
}

AddFromPartLibrary.propTypes = {
    customer: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func,
}

export default AddFromPartLibrary
